// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /award/get-mine.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeAwardGetMineBody,
  typeAwardGetMineOutput200,
} from "../../sdk/award/postAwardGetMine";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildAwardGetMineQueryKey(
  payload: typeAwardGetMineBody,
): string[] {
  const queryKeySegments: string[] = [];

  return ["post:award:awardGetMine", "svc:contest-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeAwardGetMineOutput200,
    unknown,
    typeAwardGetMineOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useAwardGetMine(
  payload: typeAwardGetMineBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildAwardGetMineQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postAwardGetMine(payload),
    ...resolvedOptions,
  });
}
